import * as React from "react";
import { useAuth0 } from "../auth/react-auth0-wrapper";

const AppLoadingBar = () => {
  const { eventBus } = useAuth0();
  const [loading, setLoading] = React.useState();

  React.useEffect(function setupListener() {
    function startLoading() {
      setLoading(true);
    }

    function endLoading() {
      setLoading(false);
    }

    eventBus.addEventListener("api-start", startLoading);
    eventBus.addEventListener("api-end", endLoading);
    eventBus.addEventListener("api-error", endLoading);

    return function cleanupListener() {
      eventBus.removeEventListener("api-start", startLoading);
      eventBus.removeEventListener("api-end", endLoading);
      eventBus.removeEventListener("api-error", endLoading);
    };
  });

  return loading ? (
    <div className="load-bar">
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
    </div>
  ) : null;
};

export default AppLoadingBar;
